interface BloomreachSdk {
  identify: (_customerIds: Record<string, string>) => void,
}

declare global {
  interface Window {
    exponea?: BloomreachSdk,
  }
}

// Bloomreach hard ID for the email address; must match the key the backend sends in `customerIds`.
const EMAIL_CUSTOMER_ID = 'registered';

/**
 * Links the visitor's Bloomreach cookie to their email address (MYR-21956).
 *
 * The SDK is injected into the page <head> by platform-edge-router, not bundled here, and its
 * snippet stubs `identify` and queues calls until the real SDK loads, so this is safe to call
 * early. It is a no-op where the snippet isn't injected (e.g. local dev).
 * Bloomreach lower-cases and trims hard IDs itself, so the email is sent as is.
 */
const identifyBloomreach = (email?: string | null): void => {
  if (!email) return;

  window.exponea?.identify({ [EMAIL_CUSTOMER_ID]: email });
};

export default identifyBloomreach;
